import React from "react";
import { Navigate } from "react-router-dom";
import logger from "../utils/logger";

interface OnboardingProtectedProps {
  children: React.ReactNode;
}

const OnboardingProtected: React.FC<OnboardingProtectedProps> = ({
  children,
}) => {
  // Check if user is authenticated
  const authUser = localStorage.getItem("authUser");

  if (!authUser) {
    // If not authenticated, redirect to login
    return <Navigate to="/auth-login" />;
  }

  try {
    const userData = JSON.parse(authUser);

    // If user has companyId, they should not access onboarding
    // Check both companyId and companyID for compatibility
    const companyId = userData.companyId || userData.companyID;

    if (companyId && companyId !== 0 && companyId !== "0" && companyId !== "") {
      return <Navigate to="/channel-session" />;
    }

    // User is authenticated but hasn't completed onboarding
    return <>{children}</>;
  } catch (e) {
    logger.error("OnboardingProtected: Error parsing auth user data:", e);
    // If there's an error parsing user data, redirect to login
    return <Navigate to="/auth-login" />;
  }
};

export { OnboardingProtected };
